import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NON_EN_CODES } from "../i18n";

const STORAGE_KEY = "i18n-lang";

export function LocaleLayout({ lang }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (NON_EN_CODES.includes(lang)) {
      // Explicit non-English route — always apply and persist
      if (lang !== i18n.language) i18n.changeLanguage(lang);
      try { localStorage.setItem(STORAGE_KEY, lang); } catch {}
    } else {
      // English fallback route — only reset to English if the user has
      // no stored non-English preference (protects locale during auth flow)
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored && NON_EN_CODES.includes(stored)) {
          // User has an active non-English preference — honour it
          if (i18n.language !== stored) i18n.changeLanguage(stored);
        } else if (i18n.language !== "en") {
          i18n.changeLanguage("en");
        }
      } catch {
        if (i18n.language !== "en") i18n.changeLanguage("en");
      }
    }
  }, [lang, i18n]);

  return <Outlet />;
}
